var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"profile-section"},[_c('div',{staticClass:"profile-section-head"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_vm._t("view-all")],2),_c('hr',{staticClass:"thick"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }